<template>
  <div id="app">
    <NuxtLoadingIndicator color="#292D32" />
    <div id="google_translate_element" style="display:none;"></div>
    
    <div class="layout position-relative">      
      <HeaderComponent
        ref="headerRef"
        :menuItems="menuItems"
        :property="property"
        :mobileMenu="mobileMenuItems"
        :searchItems="searchItems"
        @update-header-height="handleHeaderHeight"
        @update-alert="setAlertHeight"
      />

      <main
        data-scrollable
        id="main-content"
        class="main-content-container"
        role="main"
        :style="{ 
          paddingTop: property?.alert_display_type !== 'none' ? 0 : mainPadding,
          }"
      >
        <div class="page-container">
          <slot />
        </div>
      </main>

      <Popup v-if="!isDesktop"></Popup>

      <FooterComponent
        :items="footerMenuItems"
        :property="property"
        :isMobile="isMobile"
        :socialMedia="property.social_links"
      >
        <div class="d-flex justify-content-center">
          <div class="be-ix-link-block"></div>
        </div>
      </FooterComponent>
    </div>
  </div>
</template>


<script setup>
import {
  ref,
  computed,
  watch,
  onMounted,
  onUnmounted,
  onBeforeMount,
  onBeforeUnmount,
} from "vue";
import { useRoute } from "vue-router";
import { useMainStore } from "~/store/index";
import { useElementSize } from "@vueuse/core";

// Utilities and composables
const { isMobile, isTablet, isDesktop } = useMobileChecker();
const { hook } = useNuxtApp();
const route = useRoute();
const config = useRuntimeConfig();

// Store
const store = useMainStore();
const { getDataSets, propertyData, property, loadPageData, api, baseURL } =
  store;

const searchItems = _concat(
  store.stores,
  store.promotions,
  store.events,
  store.jobs
);

useHead({
  script: [
    {
      type: 'application/ld+json',
      children: JSON.stringify({
        "@context": "https://schema.org",
        "@type": "Organization",
        "name": "Highland Park Village",
        "url": "https://hpvillage.com/",
        "logo": "http://y7m.47a.mywebsitetransfer.com/wp-content/uploads/2018/06/12003021_10153659979112431_599938973927166336_n.jpg",
        "sameAs": [
          "https://www.facebook.com/highlandparkvillage/",
          "https://instagram.com/hp_village/",
          "https://www.pinterest.com/hpvillage",
          "https://twitter.com/hp_village"
        ]
      }),
    },
  ]
});

useBreadcrumbSchema();

// Hooks
hook("page:finish", () => {
  window.scrollTo(0, 0);
});

// State
const showAlert = ref(true);
const menuItems = ref([]);
const mobileMenuItems = ref([]);
const footerMenuItems = ref([]);
const headerHeight = ref(0);
const alertHeight = ref(0)

const setAlertHeight = (height) => {
  alertHeight.value = height
}

// Computed
const mainPadding = computed(() => {
  // Only apply header height padding if NOT on homepage
  return route.path === "/" || isDesktop.value
    ? "0px"
    : `calc(${headerHeight.value}px - ${alertHeight.value}px)`;
});

// Header height handler
function handleHeaderHeight(height) {
  headerHeight.value = height;
}

// Menus plus the galleries used by the footer lookbook and homepage CTAs.
const [dataSetsMenuItems, dataSetsMobileMenuItems, dataSetsFooterItems] =
  await Promise.all([
    getDataSets({ url: "data_sets/menu-items" }),
    getDataSets({ url: "data_sets/mobile-menu-items" }),
    getDataSets({ url: "data_sets/footer-menu-items" }),
    store.ensureMMData("galleries"),
  ]);

// Assign dataset values
menuItems.value = dataSetsMenuItems?.data?.data_set_items?.[0]?.data || [];
mobileMenuItems.value =
  dataSetsMobileMenuItems?.data?.data_set_items?.[0]?.data || [];
footerMenuItems.value =
  dataSetsFooterItems?.data?.data_set_items?.[0]?.data || [];

// Watchers
watch(headerHeight, (val) => {
  document.documentElement.style.setProperty("--header-height", `${val}px`);
});

// Lifecycle
onMounted(() => {
  document.documentElement.style.setProperty(
    "--header-height",
    `${headerHeight.value}px`
  );
  if (window.hideAppBootLoader) window.hideAppBootLoader();
});
</script>


<style lang="scss" scoped>
.main-content-container {
  // position: relative;
  // min-height: calc(100vh - v-bind(headerHeight));

  @media only screen and (max-width: 1024px) {
    // top: v-bind(headerHeight);
    // top: auto;
    // position: relative;
  }
}
</style>
